export default {
  auszahlungsuebersicht: "d3bf5f4a-62fe-430d-b491-4ed43072a147",
};
